(function () {
  'use strict';

  angular.module('app').component('bookingGuestDetail', bookingGuestDetail());

  function bookingGuestDetail() {
    return {
      bindings: {
        guest: '=',
        booking: '=',
        mode: '<',
        onBookingGuestSaved: '&',
        onBookingGuestCanceled: '&',
      },
      controller: BookingGuestDetailCtrl,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/bookings/booking-guests/booking-guest-detail/booking-guest-detail.component.html',
    };
  }

  BookingGuestDetailCtrl.$inject = ['CONFIGURATIONS', 'UtilService', 'GuestService'];

  function BookingGuestDetailCtrl(config, UtilService, GuestService) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    var fieldsDefinition = [
      'name',
      'last_name',
      'type',
      'birthday',
      'gender',
      'height',
      'height_unit',
      'weight',
      'weight_unit',
      'title',
      'phone',
      'age',
      'email',
    ];

    vm.dateDisplay = config.DATE_DISPLAY;
    vm.genders = config.GENDERS;
    vm.paxTypes = config.PAX_TYPES;
    vm.heightUnits = config.HEIGHT_UNITS;
    vm.weightUnits = config.WEIGHT_UNITS;

    // Methods
    vm.editBookingGuest = editBookingGuest;
    // vm.cancelEdit = cancelEdit;
    vm.saveBookingGuest = saveBookingGuest;
    vm.cancel = cancel;

    vm.$onInit = function () {
      if (vm.guest.id) {
        // Edit
        setItemOptions(vm.guest, vm.mode);
      } else {
        vm.createMode = true;
      }
    };

    function setItemOptions(item, mode) {
      vm.createMode = false;
      vm.editMode = false;
      vm.viewMode = true;

      if (mode === 'edit') {
        editBookingGuest();
      }

      vm.originalItem = angular.copy(item); // store server data
    }

    function editBookingGuest() {
      vm.editMode = true;
      vm.viewMode = false;
    }

    /*function cancelEdit() {
            vm.item = vm.originalItem;
            setItemOptions(vm.item);
        }*/

    // Create/Update
    function saveBookingGuest(isFormValid) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.serverErrors = [];
        vm.formErrors = true;
      } else {
        if (vm.UtilService.isFormDataChanged(vm.guest, vm.originalItem, fieldsDefinition)) {
          vm.sendingForm = true;

          GuestService.saveBookingGuest(vm.guest, vm.booking.id).then(function (data) {
            if (!data.errors) {
              // Success
              vm.onBookingGuestSaved({ guestObj: data });
            } else {
              vm.serverErrors = vm.UtilService._showItemServerErrors(data.errors);
              vm.formErrors = true;
            }

            vm.sendingForm = false;
          });
        } else {
          cancel();
        }
      }
    }

    function cancel() {
      // if (vm.editMode){
      //     vm.cancelEdit();
      //     return;
      // }

      vm.onBookingGuestCanceled();
    }
  }
})();
